import React from 'react';
import block from 'bem-cn';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { actions } from 'features/assistant';

import './AssistantButton.scss';

const b = block('assistant-button');

const AssistantButton = () => {
  const dispatch = useDispatch();

  const locale = useSelector(state => state.locale.locale, shallowEqual);

  const handleOpenModal = () => {
    dispatch(actions.handleAssistantModal(true));
  };

  return (
    <div onClick={handleOpenModal} className={b()}>
      <span>{locale.assistant}</span>
    </div>
  );
};

export default AssistantButton;
